"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_navigation_service_1 = require("../../services/http-navigation.service");
var navigation_service_1 = require("../navigation/api/navigation.service");
var http_header_bar_service_1 = require("../../services/http-header-bar.service");
var header_bar_service_1 = require("../header-bar/api/header-bar.service");
var core_1 = require("@angular/core");
var shared_module_1 = require("../shared.module");
var common_1 = require("@angular/common");
var system_logout_handler_1 = require("../../system-logout-handler");
var online_providers_module_1 = require("./online-providers.module");
var mat_paginator_intl_impl_1 = require("../../services/mat-paginator-intl-impl");
var material_1 = require("@angular/material");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var ɵ0 = function (messageService) { return new idm_ng_controls_1.ControlsTranslationService(messageService); };
exports.ɵ0 = ɵ0;
/**
 * Module for providing HTTP implementations of services used in shell after login
 */
var ShellOnlineProvidersModule = /** @class */ (function () {
    function ShellOnlineProvidersModule(systemLogoutHandler) {
        this.systemLogoutHandler = systemLogoutHandler;
    }
    ShellOnlineProvidersModule = __decorate([
        core_1.NgModule({
            imports: [shared_module_1.SharedModule, common_1.CommonModule, online_providers_module_1.OnlineProvidersModule],
            providers: [
                http_navigation_service_1.HttpNavigationService,
                http_header_bar_service_1.HttpHeaderBarService,
                { provide: header_bar_service_1.HeaderBarService, useClass: http_header_bar_service_1.HttpHeaderBarService },
                { provide: navigation_service_1.NavigationService, useClass: http_navigation_service_1.HttpNavigationService },
                { provide: material_1.MatPaginatorIntl, useClass: mat_paginator_intl_impl_1.MatPaginatorIntlImpl },
                {
                    provide: idm_ng_controls_1.ControlsTranslationService,
                    useFactory: ɵ0,
                    deps: [idm_message_language_service_client_js_1.MessageService],
                },
                { provide: idm_application_properties_service_client_js_1.StaticResourceUrlProvider, useClass: idm_application_properties_service_client_js_1.MinioStaticResourceUrlProvider }
            ],
            exports: []
        }),
        __metadata("design:paramtypes", [system_logout_handler_1.SystemLogoutHandler])
    ], ShellOnlineProvidersModule);
    return ShellOnlineProvidersModule;
}());
exports.ShellOnlineProvidersModule = ShellOnlineProvidersModule;
//# sourceMappingURL=shell-online-providers.module.js.map